import styled from 'styled-components'
import { CardBody, Col, Row } from 'shards-react'

export const CustomizedRow = styled(Row)`
    flex-direction: column;

    @media (min-width: 1100px) {
        flex-direction: row;
    }
`

export const CustomizedCol = styled(Col)`
    margin-bottom: 10px;
`
export const CustomizedCardBody = styled(CardBody)`
    width: 100%;
`
export const Span = styled.span`
    font-size: '18px';
    font-weight: '800';
`
